"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function VXEUtils(app, XEUtils, options) {
  var isV3 = typeof app !== 'function';
  var mounts = options && options.mounts && options.mounts.length ? options.mounts.join(';') : [];
  var variate = '$utils';

  var setMount = function setMount(name) {
    if (mounts.indexOf(name) > -1) {
      if (isV3) {
        app.config.globalProperties['$' + name] = XEUtils[name];
      } else {
        app.prototype['$' + name] = XEUtils[name];
      }
    }
  };

  if (isV3) {
    app.config.globalProperties[variate] = XEUtils;
  } else {
    Object.defineProperty(app.prototype, variate, {
      get: function get() {
        XEUtils.$context = this;
        return XEUtils;
      }
    });
  }

  setMount('cookie');
  setMount('browse');
  setMount('locat');
}

var _default = VXEUtils;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vxe-utils/dist/vxe-utils.common.js
// module id = J3kS
// module chunks = 20